import {memo, useContext, useMemo, useRef, useState} from "react";
import Button from "components/Common/Button";
import {ASSET_TYPE} from "components/Layout/constants";
import {
  UploadingAssetDispatchContext,
  UploadProgressDispatchContext,
} from "components/Layout/components/ObjectPanel/UploadProgressProvider";
import useUploadAsset from "components/Layout/components/ObjectPanel/hooks/useUploadAsset";
import styles from "./index.module.scss";
import {TypeAsset} from "components/Layout/components/ObjectPanel/TypeAsset";

function MyTab() {
  const inputRef = useRef(null);
  const setUploadProgress = useContext(UploadProgressDispatchContext);
  const setUploadingAssetInfo = useContext(UploadingAssetDispatchContext);
  const {createAsset} = useUploadAsset(setUploadProgress.updateUploadProgress, setUploadingAssetInfo.updateUploadingAssetInfo);

  const fileOpenHandler = () => {
    inputRef.current.click();
  };

  const [currentType, setCurrentType] = useState(ASSET_TYPE.MODEL);
  const onChangeFileUpload = e => {
    const value = e.target.files[0];
    createAsset(value, setCurrentType);
  };
  const memoizedSetCurrentType = useMemo(() => setCurrentType, []);

  return (
    <div className={styles.container}>
      <>
        <Button className={styles.upload} type="primary" onClick={fileOpenHandler}>
          Upload
        </Button>
        <input type="file" hidden ref={inputRef} onChange={onChangeFileUpload} />
      </>
      <TypeAsset currentType={currentType} memoizedSetCurrentType={memoizedSetCurrentType} />
    </div>
  );
}

export default memo(MyTab);
